import { AxiosResponse } from "axios";
import { httpClient } from "./API";
import { BillingPaymentScheduleCalendar } from "@/models/billingPaymentSchedule";

export const getBillingPaymentScheduleAPI = async (
  officeId: number,
  year: number,
  month: number
): Promise<AxiosResponse<BillingPaymentScheduleCalendar>> => {
  return httpClient.get(
    `core/internal/calgary/billingPaymentSchedules/${officeId}`,
    { params: { year, month } }
  );
};
